<script setup lang="ts">
import { scheduleFieldText } from './scheduleGroups';
import { useTableSchedules } from './useCardSchedules';

/**
 * One schedule field of a custom list, such as its schedules' start dates, as a table
 * cell. It draws one value per schedule the row shows, in the order the Schedules cell
 * draws them, so the second value here and the second one-liner there are the same
 * schedule. A schedule that leaves the field empty reads "–". A row that shows no
 * schedules draws nothing.
 *
 * The values sit in one row that clips with an ellipsis, like the Schedules cell's.
 */
const props = defineProps<{
    row: Record<string, unknown>;
    /** The schedule field, such as "date" or "custom_playlist_schedule_type_id". */
    field: string;
}>();

const entries = useTableSchedules(() => props.row);
</script>

<template>
    <span v-if="entries.length > 0" class="block min-w-0 truncate tabular-nums" data-testid="schedule-field-cell">
        <span
            v-for="entry in entries"
            :key="entry.key"
            class="mr-3 last:mr-0"
            data-testid="schedule-field-value"
            :data-schedule-id="entry.schedule.id"
            >{{ scheduleFieldText(entry.schedule, field) }}</span
        >
    </span>
</template>
